import * as H from "history";
import React, { MouseEvent } from "react";
import { NavLink } from "react-router-dom";
import {
  ComponentPermission,
  EComponentId,
  PermissionProps,
} from "../../Model/Permission";
import { usePermission } from "../Common/PermissionProvider";
import PermissionUtil from "../../Utility/PermissionUtil";

interface Props extends PermissionProps {
  to: string;
  style?: React.CSSProperties;
  icon: React.ReactNode;
  label: string;
  disabled?: boolean;
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void; 
}

export default function NavItem({
  to,
  icon,
  label,
  style = {},
  permissions,
  componentId,
  disabled = false,
  onClick = () => {},
}: Props) {
  const componentCanRead = PermissionUtil.canReadComponent(
    permissions,
    componentId
  );

  // check use Permission and have permissions or discard permissions
  const showComponent = permissions ? componentCanRead && permissions : true;

  const isChildPath = (parentFullPath: string, childFullPath: string) => {
    const parents = parentFullPath.split("/");
    const childs = childFullPath.split("/");

    let result = true;
    for (let index = 0; index < parents.length; index++) {
      if (parents[index] !== childs[index]) {
        result = false;
        break;
      }
    }

    if (!parents && !childs) {
      result = false;
    }

    return result;
  };

  const handleIsActive = (match: any, location: H.Location) => {
    return to === location.pathname || isChildPath(to, location.pathname);
  };

  return (
    <>
      {showComponent && (
        <NavLink
          style={{
            color: "white",
            opacity: disabled ? "0.5" : 1,
            ...style,
          }}
          to={disabled ? "#" : to}
          onClick={onClick}
          isActive={(match, location) => {
            return handleIsActive(match, location);
          }}
          activeClassName="sidebar-item-active bg-selected-dark"
        >
          <div className="sidebar-item">
            <div className="sidebar-item-icon">{icon}</div>
            <div className="sidebar-item-text">{label} </div>
          </div>
        </NavLink>
      )}
    </>
  );
}

export const NavItemWithPermission = usePermission(NavItem);
